exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style-module__title___1hRlk{text-transform:capitalize}.style-module__text___3w6CV{color:#3B436C}.style-module__cross-icon___3vy4W{cursor:pointer}.style-module__cross-icon___3vy4W svg{width:1rem;height:1rem}.style-module__cross-icon___3vy4W svg path{fill:#FF0099}.style-module__loading___3qhsn{display:flex;align-items:center;justify-content:flex-end}.style-module__loading__circle___3QROt{stroke-width:2}.style-module__loading___3qhsn.style-module__loading_primary___7Wi8z{color:#FF0099}\n", ""]);

// exports
exports.locals = {
	"title": "style-module__title___1hRlk",
	"text": "style-module__text___3w6CV",
	"cross-icon": "style-module__cross-icon___3vy4W",
	"loading": "style-module__loading___3qhsn",
	"loading__circle": "style-module__loading__circle___3QROt",
	"loading_primary": "style-module__loading_primary___7Wi8z"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/TeachersModal/style.module.scss
// module id = 1798
// module chunks = 0